<template>
    <v-container>

        <v-row>
            <v-col>
                <div class="font-weight-bold mt-10 title-page" tabindex="0">Lista de Credores</div>
            </v-col>
        </v-row>

        <br>

        <div v-html="dataset.description" tabindex="0"></div>

        <v-row>
            <v-col sm="12">
                <v-text-field id="name" label="Buscar pelo nome do credor" hint="No mínimo 4 dígitos para fazer a busca"
                    persistent-hint v-model="filter" outlined @keyup.enter="handleEnterPress" tabindex="0"
                    aria-label="Digitar o nome para buscar na lista de credores"></v-text-field>
                <v-btn class="mt-2" id="btnFilter" type="submit" color="primary" dark elevation="2" large
                    :disabled="isFilterDisabled" @click="!isFilterDisabled ? reload() : null" tabindex="0"
                    aria-label="Botão para fazer a busca">Filtrar</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title" tabindex="0" aria-hidden="true">Lista de
                        credores</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum credor foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <!-- <template v-slot:[`item.amount`]="{ item }">
                                <span>{{ item.amount | currency }}</span>
                            </template> -->

                            <template v-slot:[`item.amount`]="{ item }">
                                <span>{{ formatValue(item.amount, item.currency) }}</span>
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                <v-chip label text-color="primary">
                                    {{ getClassName(item.type) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-btn dense elevation="0" @click="creditorDetails(item)">
                                    <span class="caption font-weight-bold">Ver</span>
                                    <v-icon small>mdi-arrow-right</v-icon>
                                </v-btn>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- <v-row>
            <v-col>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <div class="collapse-title" tabindex="0">Lista de credores em pdf - Edital do art. 7º, § 2º, da LRF</div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row>
                                <v-col>
                                    <v-card class="mb-2" elevation="0" v-for="(item, index) in fileList_new" :key="index">
                                        <v-card-text>
                                            <a 
                                                style="text-decoration: none;" 
                                                
                                                href="#"
                                                @click.prevent="downloadFile(item.resource_id, item.name)"
                                            >
                                            LISTA DE CREDORES - GRUPO 123 MILHAS - 
                                            <span v-if="item.class === 'I'">CLASSE I - TRABALHISTAS</span>
                                            <span v-else-if="item.class === 'IV'">CLASSE IV - ME EPP</span>
                                            <span v-else>CLASSE III - QUIROGRAFÁFIOS - LETRA {{ removePdfExtension(item.name) }}</span>
                                          </a>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row> -->

        <v-row>
            <v-col>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <div class="collapse-title" tabindex="0">Lista de credores em pdf - Edital do art. 7, § 2º,
                                da LRF
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row>
                                <v-col>
                                    <v-card elevation="0" class="mb-2">
                                        <v-card-text><a style="text-decoration: none;" target="_blank" tabindex="0"
                                                href="https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/lista-credores-artigo-7/ME_EPP.pdf">
                                                LISTA DE CREDORES - GRUPO 123 MILHAS - CLASSE IV - ME
                                                EPP</a></v-card-text>
                                    </v-card>
                                    <v-card elevation="0" class="mb-2">
                                        <v-card-text><a style="text-decoration: none;" target="_blank" tabindex="0"
                                                href="https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/lista-credores-artigo-7/Trabalhista.pdf">
                                                LISTA DE CREDORES - GRUPO 123 MILHAS - CLASSE I -
                                                TRABALHISTAS</a></v-card-text>
                                    </v-card>
                                    <v-card class="mb-2" elevation="0" v-for="(item, index) in fileList" :key="index">
                                        <v-card-text><a style="text-decoration: none;" target="_blank"
                                                :href="'https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/lista-credores-artigo-7/' + item.value + '.pdf'">LISTA
                                                DE CREDORES - GRUPO 123 MILHAS - CLASSE III - QUIROGRAFÁFIOS - LETRA {{
                                                    item.value }}</a></v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <div class="collapse-title" tabindex="0">Lista de credores em pdf - Edital do art. 52, § 1º,
                                da LRF
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row>
                                <v-col>
                                    <v-card elevation="0" class="mb-2">
                                        <v-card-text><a style="text-decoration: none;" target="_blank" tabindex="0"
                                                href="https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/ME_EPP.pdf">
                                                LISTA DE CREDORES - GRUPO 123 MILHAS - CLASSE IV - ME
                                                EPP</a></v-card-text>
                                    </v-card>
                                    <v-card elevation="0" class="mb-2">
                                        <v-card-text><a style="text-decoration: none;" target="_blank" tabindex="0"
                                                href="https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Trabalhista.pdf">
                                                LISTA DE CREDORES - GRUPO 123 MILHAS - CLASSE I -
                                                TRABALHISTAS</a></v-card-text>
                                    </v-card>
                                    <v-card class="mb-2" elevation="0" v-for="(item, index) in fileList" :key="index">
                                        <v-card-text><a style="text-decoration: none;" target="_blank"
                                                :href="item.link">LISTA
                                                DE CREDORES - GRUPO 123 MILHAS - CLASSE III - QUIROGRAFÁFIOS - LETRA {{
                                                    item.value }}</a></v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <div class="collapse-title" tabindex="0">Lista de credores em pdf - Fase de revisão de créditos
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-row>
                                <v-col>
                                    <v-card elevation="0" class="mb-2">
                                        <v-card-text><a style="text-decoration: none;" target="_blank" tabindex="0"
                                                href="https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/ME_EPP.pdf">
                                                LISTA DE CREDORES - GRUPO 123 MILHAS - CLASSE IV - ME
                                                EPP</a></v-card-text>
                                    </v-card>
                                    <v-card elevation="0" class="mb-2">
                                        <v-card-text><a style="text-decoration: none;" target="_blank" tabindex="0"
                                                href="https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Trabalhista.pdf">
                                                LISTA DE CREDORES - GRUPO 123 MILHAS - CLASSE I -
                                                TRABALHISTAS</a></v-card-text>
                                    </v-card>
                                    <v-card class="mb-2" elevation="0" v-for="(item, index) in consolidatedList" :key="index">
                                        <v-card-text>
                                            <a style="text-decoration: none;" target="_blank" :href="item.link">
                                                LISTA DE CREDORES - GRUPO 123 MILHAS - CLASSE III - QUIROGRAFÁRIOS - {{ item.value.length === 1 ? 'LETRA' : '' }} {{ item.value.toUpperCase() }}
                                            </a>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>

        <!-- MODAL -->
        <v-dialog v-model="dialog" width="800px" scrollable>
            <v-card class='pa-3'>
                <v-card-title>
                    <v-row justify="center">
                        <v-col lg="12">
                            <h1 class="custom-modal-title text-uppercase primary--text font-weight-bold" tabindex="1">
                                VERIFICAÇÃO DE CRÉDITOS - Resumo do credor

                            </h1>
                            <br>
                            <span class="resume-modal-case-name">{{ dataList.modalData.name }}</span>
                            <br>

                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text v-if="dataset.data">
                    <v-row no-gutters>
                        <v-col>
                            <v-row>
                                <v-col class="bordered-item mt-5">
                                    <creditor-phase-history v-if="dataset.data.phases && dataset.data.phases.length"
                                        :phases="dataset.data.phases" :currency="dataset.data.currency"
                                        @details="moreDetails" />
                                    <p v-else class="mb-0">Sem registros</p>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-text v-else>
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary darken-1" text @click="dialog = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para mostrar texto do motivo / analise-->
        <v-dialog v-model="dialogReason" max-width="600">
            <v-card>
                <v-card-title class="blue--text text--darken-2"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center;">
                    Analise
                </v-card-title>
                <v-card-text v-if="dataset.data && reasonText" tabindex="0" class="scrollable-text">
                    <!-- <p tabindex="0">
                        <br />
                        <span class="section-info-value text-uppercase"
                            v-html="stripHtmlTags(dataset.data.value_2_reason)"></span>
                    </p> -->
                    <div v-html="reasonText"></div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="fixed-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="grey" tabindex="0" text @click="dialogReason = false"
                        aria-label="Botão para fechar a janela com a descrição do motivo">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import 'moment/locale/pt-br';

import { eventHub } from "@/main"

import axios from "axios";

import _ from 'lodash';

import CreditorPhaseHistory from '@/components/creditor/CreditorPhaseHistory.vue';

export default {
    components: { CreditorPhaseHistory },

    data: () => ({
        user: null,
        dialogReason: false,
        reasonText: '',
        filter: null,
        dataset: {
            description: '',
            data: [],
        },
        dialog: false,
        dataList: {
            filter: {
                name: "",
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "CPF/CNPJ", value: "registration" },
                { text: "Classe", value: "type" },
                { text: "Valor", value: "amount" },
                { text: 'Detalhes', value: 'actions', sortable: false }
            ],
            modalData: {},
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 5,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [5, 10, 20, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
        fileList_new: [],
        fileList: [
            { value: "A", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-A.pdf" },
            { value: "B", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-B.pdf" },
            { value: "C", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-C.pdf" },
            { value: "D", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-D.pdf" },
            { value: "E", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-E.pdf" },
            { value: "F", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-F.pdf" },
            { value: "G", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-G.pdf" },
            { value: "H", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-H.pdf" },
            { value: "I", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-I.pdf" },
            { value: "J", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-J.pdf" },
            { value: "K", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-K.pdf" },
            { value: "L", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-L.pdf" },
            { value: "M", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-M.pdf" },
            { value: "N", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-N.pdf" },
            { value: "O", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-O.pdf" },
            { value: "P", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-P.pdf" },
            { value: "Q", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-Q.pdf" },
            { value: "R", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-R.pdf" },
            { value: "S", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-S.pdf" },
            { value: "T", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-T.pdf" },
            { value: "U", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-U.pdf" },
            { value: "V", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-V.pdf" },
            { value: "W", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-W.pdf" },
            { value: "X", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-X.pdf" },
            { value: "Y", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-Y.pdf" },
            { value: "Z", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/Letra-Z.pdf" },
        ],
        consolidatedList: [
            { value: "A", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-A.pdf" },
            { value: "B", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-B.pdf" },
            { value: "C", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-C.pdf" },
            { value: "D", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-D.pdf" },
            { value: "E", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-E.pdf" },
            { value: "F", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-F.pdf" },
            { value: "G", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-G.pdf" },
            { value: "H", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-H.pdf" },
            { value: "I", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-I.pdf" },
            { value: "J", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-J.pdf" },
            { value: "K", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-K.pdf" },
            { value: "L", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-L.pdf" },
            { value: "M", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-M.pdf" },
            { value: "N", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-N.pdf" },
            { value: "O", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-O.pdf" },
            { value: "P", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-P.pdf" },
            { value: "Q", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-Q.pdf" },
            { value: "R", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-R.pdf" },
            { value: "S", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-S.pdf" },
            { value: "T", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-T.pdf" },
            { value: "U", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-U.pdf" },
            { value: "V", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-V.pdf" },
            { value: "W", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-W.pdf" },
            { value: "X", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-X.pdf" },
            { value: "Y", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-Y.pdf" },
            { value: "Z", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Letra-Z.pdf" },
            { value: "Outros", link: "https://rj123milhas-docs-dev.s3.sa-east-1.amazonaws.com/list-creditors/lista-consolidada/Outros.pdf" },
        ],
    }),

    mounted: function () {
    },

    computed: {
        isFilterDisabled() {
            return !this.filter || this.filter.length < 4;
        }
    },

    created() {
        this.loadText();
        this.loadList();

        this.$ga.event({
            eventCategory: 'page',
            eventAction: 'action',
            eventLabel: 'click',
            eventValue: 'list'
        })
    },

    methods: {

        openRegister() {
            eventHub.$emit("DIALOG-REGISTER", true)
        },

        handleEnterPress() {
            if (!this.isFilterDisabled) {
                this.reload();
            }
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load();
        },

        reload() {
            this.dataList.options.page = 1;
            this.dataList.options.size = 10;
            this.load();
        },

        getClassName(classId) {

            switch (classId) {
                case 1:
                    return "Trabalhista";
                case 2:
                    return "Garantia Real";
                case 3:
                    return "Quirografário";
                case 4:
                    return "ME/EPP";
                case 5:
                    return "Extraconcursais";
                case 6:
                    return "Ilíquidos";
                case 7:
                    return "Fiscal";
                case 8:
                    return "Não Sujeito";
                case 9:
                    return "Subordinados";
                default:
                    return "N/A";
            }
        },

        stripHtmlTags(value) {
            if (!value) return '';
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = value;
            return tempDiv.textContent || tempDiv.innerText || "";
        },

        formatValue(value, currency) {
            if (value === null || value === undefined) {
                return 'N/A';
            }

            let options = {
                style: 'currency',
                currency: 'BRL' // Default
            };

            switch (currency) {
                case 1:
                    options.currency = 'BRL';
                    break;
                case 2:
                    options.currency = 'USD';
                    break;
                case 3:
                    options.currency = 'EUR';
                    break;
                default:
                    options.currency = 'BRL';
            }

            return new Intl.NumberFormat('pt-BR', options).format(value);
        },


        // formatValue(value) {

        //     if (value === null || value === undefined) {
        //         return 'N/A';
        //     }

        //     return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
        // },


        async creditorDetails(item) {

            this.dataset.data = null
            this.dataList.modalData = item
            this.dialog = true;

            try {
                // Credor excluído do QGC é identificado pela movimentação de exclusão
                const params = item.excluded ? { movement_id: item.movement_id } : { id: item.id }
                const result = await axios.get('/api/creditor-list/detail', { params })

                if (result && result.data && result.data.content && result.data.content.data) {
                    this.dataset.data = result.data.content.data;
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }

        },


        async loadText() {
            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                    params: { keys: 'creditor-list-description' }
                })

                this.dataset.description = result.data.content && result.data.content.length > 0 ? result.data.content[0].value : '';

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        async load() {

            this.dataList.loading = true;

            var limit = this.dataList.options.size;

            try {

                const result = await axios.get('/api/creditor-list', { params: { page: this.dataList.options.page, limit: limit, search: this.filter } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async loadList() {

            this.dataList.loading = true;

            try {

                const result = await axios.get('/api/qgc-get-pdf-files');

                this.fileList_new = result.data.files

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async downloadFile(resourceId, fileName) {
            try {
                const response = await axios.get(`/api/download-pdf-files?resourceId=${resourceId}`, {
                    responseType: 'blob'
                });

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

            } catch (error) {
                console.error(`Erro ao baixar ${fileName}:`, error);
            }
        },

        removePdfExtension(fileName) {
            return fileName.replace('.pdf', '');
        },

        moreDetails(reason) {
            this.reasonText = reason;

            this.dialogReason = true;
            this.dialog = false;


        },

    }
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.collapse-title {
    text-transform: none;
    color: var(--v-primary-base);
    font-size: 24px;
    font-weight: 700;
}

#btnFilter.v-btn--disabled {
    background-color: rgb(197, 192, 192) !important;
}

.bordered-item {
    border: 1px solid #ccc;
    padding: 16px;
    border-radius: 4px;
}

.scrollable-text {
    max-height: 600px;
    overflow-y: auto;
    padding-bottom: 16px;
}

.fixed-actions {
    border-top: 1px solid #e0e0e0;
    position: sticky;
    bottom: 0;
    background-color: #fff;
    padding: 8px 16px;
}
</style>
